import React from 'react';
import ReactDOM from 'react-dom';
//import './index.css';
// Create Import File
import './index_sass.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Suspense } from 'react';

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={ null }>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
